/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
import merge from 'lodash/merge'
import nurigoTheme from 'themes/nurigo-material'

// material UI
import { MuiThemeProvider } from '@material-ui/core/styles'
import createTheme from '@material-ui/core/styles/createTheme'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'

import {
  MdFileDownload as MdFileDownloadIcon,
  MdPostAdd as MdPostAddIcon
} from 'react-icons/md'
import { ReactComponent as RcsLogo } from 'static/image/logo/rcs_logo.svg'

// my components
// import UserComponentName from 'components/molecules/UserComponentName'
import TableContainer from 'containers/TableContainer'
import SearchContainer from 'containers/SearchContainer'
import CommonButton from 'containers/CommonButtonContainer'

// libraries
import config from 'config'

const styles = theme => ({
  root: {
    maxWidth: 1200,
    margin: '0 auto'
  },
  paper: {
    padding: theme.spacing(2)
  }
})
export const useProps = {}
const newTheme = createTheme(
  merge({}, nurigoTheme, {
    palette: {
      primary: {
        main: config.purplebookTab.rcs.mainColor,
        dark: config.purplebookTab.rcs.darkColor
      }
    }
  })
)
/**
 * (작성된 설명이 없습니다.)
 */
const RcsTemplateList = ({ classes, proxy, ...props }) => {
  const { onClickCreateTemplate, onClickSyncTemplate } = proxy
  return (
    <MuiThemeProvider theme={newTheme}>
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SearchContainer searchKey="rcsTemplates" autoListen />
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <TableContainer
                tableKey="rcsTemplates"
                sideEl={
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm="auto">
                      <CommonButton
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={onClickCreateTemplate}
                      >
                        <MdPostAddIcon
                          style={{ marginRight: 4, fontSize: '1.4em' }}
                        />
                        RCS 템플릿 생성
                      </CommonButton>
                    </Grid>
                    <Grid item xs={12} sm="auto">
                      <CommonButton
                        fullWidth
                        variant="outlined"
                        tooltipTitle="RCS 비즈 센터 페이지에서 등록 후 템플릿을 불러올 수 있습니다."
                        wait={800}
                        clickLoading
                        onClick={onClickSyncTemplate}
                      >
                        <RcsLogo
                          style={{
                            marginRight: 4,
                            width: '1.4em',
                            height: '1.4em',
                            verticalAlign: 'bottom'
                          }}
                        />
                        RCS 승인 템플릿 가져오기
                      </CommonButton>
                    </Grid>
                  </Grid>
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
    </MuiThemeProvider>
  )
}

RcsTemplateList.defaultProps = setDefaultProps(useProps)
RcsTemplateList.propTypes = setPropTypes(useProps)
export default withStyles(styles)(RcsTemplateList)
